<template>
  <svg
    width="8px"
    height="8px"
    viewBox="0 0 8 8"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Close</title>
    <g
      id="Cart"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="[CART]POPUP-Desktop"
        transform="translate(-1409.000000, -44.000000)"
        fill="#000000"
        fill-rule="nonzero"
      >
        <g
          id="Header"
          transform="translate(24.000000, 36.000000)"
        >
          <g
            id="Group-3"
            transform="translate(1386.000000, 9.000000)"
          >
            <polygon
              id="Line-4"
              points="-0.810660172 0.25 0.25 -0.810660172 6.81066017 5.75 5.75 6.81066017"
            />
            <polygon
              id="Line-4"
              points="6 -1.06066017 7.06066017 0 0 7.06066017 -1.06066017 6"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>